import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
// import Vant from 'vant'
import { Popup } from "vant";
import { Search } from "vant";
import { NavBar } from "vant";
import { Icon } from "vant";
import { Tab, Tabs } from "vant";
import { List } from "vant";
import { Button } from "vant";
import { Cell } from "vant";
import { PullRefresh } from "vant";
import { NoticeBar } from "vant";
import { Image as VanImage } from "vant";
import { Overlay } from "vant";
import "vant/lib/index.css";
import "./assets/css/base.css";
import "lib-flexible/flexible.js";
import "amfe-flexible";
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
// app.use(Vant)
app.use(Popup);
app.use(Search);
app.use(NavBar);
app.use(Icon);
app.use(Tab);
app.use(Tabs);
app.use(List);
app.use(Button);
app.use(Cell);
app.use(VanImage);
app.use(PullRefresh);
app.use(Overlay);
app.use(NoticeBar);
app.use(router).mount("#app");
